import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3acefe1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: { width: '100%', fontSize: '0.8rem' } }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "TT", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Mã VT", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Tên vật tư", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Đặc tính", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  rowspan: "2",
  class: "text-center"
}, "Đ/vị tính", -1))
const _hoisted_7 = {
  colspan: "3",
  class: "text-center"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Số lượng"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Đơn giá"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center break-word" }, "Thành tiền")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "A"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "B"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "D"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "E"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "1"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "3 = 1 * 2")
], -1))
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end fw-bolder" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "5"
}, " Cộng ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "-", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-center" }, "-", -1))
const _hoisted_18 = { class: "text-end fw-bolder" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "17",
  class: "text-center"
}, "Không có dữ liệu", -1))
const _hoisted_21 = [
  _hoisted_20
]

import { computed, PropType } from 'vue';
import { ITongHopVatTuResponseBase } from '@/core/interfaces/ApiResponses';
import { formatCurrencyAndQuantity } from '@/core/helpers/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'TongHopVatTuTable',
  props: {
  isTongHopNhap: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<ITongHopVatTuResponseBase[]>,
    default: () => ([]),
  },
},
  setup(__props) {

const props = __props;

const totalThanhTien = computed(() => {
  let result = 0;

  props.items.forEach(({ thanh_tien }) => {
    result += +thanh_tien;
  });

  return formatCurrencyAndQuantity(Math.round(result), false);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("tr", null, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createElementVNode("th", _hoisted_7, _toDisplayString(__props.isTongHopNhap ? 'Nhập' : 'Xuất') + " trong kỳ", 1)
    ]),
    _hoisted_8,
    _hoisted_9,
    (__props.items.length)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.id
            }, [
              _createElementVNode("td", _hoisted_10, _toDisplayString(index + 1), 1),
              _createElementVNode("td", null, _toDisplayString(item.ma_vat_tu), 1),
              _createElementVNode("td", null, _toDisplayString(item.ten_vat_tu), 1),
              _hoisted_11,
              _createElementVNode("td", null, _toDisplayString(item.don_vi_tinh), 1),
              _createElementVNode("td", _hoisted_12, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.so_luong)), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(formatCurrencyAndQuantity)(+item.don_gia)), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(_unref(formatCurrencyAndQuantity)(Math.round(+item.thanh_tien), false)), 1)
            ]))
          }), 128)),
          _createElementVNode("tr", null, [
            _hoisted_15,
            _hoisted_16,
            _hoisted_17,
            _createElementVNode("td", _hoisted_18, _toDisplayString(totalThanhTien.value), 1)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("tr", _hoisted_19, _hoisted_21))
  ]))
}
}

})